module.exports = __webpack_public_path__ + "static/media/whats-app-whatsapp-whatsapp-icon-svgrepo-com.a10b4d0d.svg";